// import { createRoot } from 'react-dom/client';
// import App from './App';
// import './styles/global.scss';
//
// // Set document title from environment variable
// document.title = process.env.REACT_APP_TITLE || 'Default App Title'; // Add a fallback
//
// createRoot(document.getElementById('root')!).render(<App />);
import 'antd/dist/reset.css';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { ConfigProvider } from 'antd';
// import reportWebVitals from './reportWebVitals';
import store from './setupStore';
import enUS from 'antd/lib/locale/en_US';

import './assets/styles/index.scss';
import { WebSocketProvider } from './providers/WebSocketProvider';
import App from './components/app';
import { syncStoredBackendsWithConfiguration } from './utils/backend-availability';

syncStoredBackendsWithConfiguration();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      useErrorBoundary: false,
      refetchOnWindowFocus: false,
      retry(failureCount, error: any) {
        if (error.status === 404) return false;
        else return failureCount < 2;
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <Router>
        <QueryParamProvider ReactRouterRoute={Route}>
          <ConfigProvider locale={enUS}>
            <WebSocketProvider>
              <App />
            </WebSocketProvider>
          </ConfigProvider>
        </QueryParamProvider>
      </Router>
      <ReactQueryDevtools />
    </QueryClientProvider>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();






